/** The most rows a list request may ask for, and how many it gets when it names no limit. The API
 * checks both; a screen that reads a whole list asks for the most, one page at a time. */
export const PAGE_LIMIT_MAX = 200;
export const PAGE_LIMIT_DEFAULT = 50;

/** Nancy's graph products arrive in pages this big: the API's cap, and what both apps ask for. */
export const GRAPH_PRODUCTS_PAGE = 2000;

/** The longest search a list takes; the web's search box stops there too. */
export const SEARCH_MAX_LENGTH = 120;

/** The page sizes a list offers; the footer and the address both accept only these. */
export const PAGE_SIZES = [25, 50, 100] as const;
